'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const ZIPIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="ZIPIcon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        id="Zip-File--Streamline-Ultimate"
        height="24"
        width="24"
      >
        <desc>Zip File Streamline Icon: https://streamlinehq.com</desc>
        <path
          stroke={sx?.color || '#3d517b8f'}
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M21.21 4.50002c0.0927 0.09344 0.166 0.20425 0.2158 0.32609 0.0497 0.12184 0.075 0.2523 0.0742 0.38391V22.5c0 0.2652 -0.1054 0.5196 -0.2929 0.7071 -0.1875 0.1876 -0.4419 0.2929 -0.7071 0.2929h-17c-0.26522 0 -0.51957 -0.1053 -0.70711 -0.2929C2.60536 23.0196 2.5 22.7652 2.5 22.5V1.50002c0 -0.26522 0.10536 -0.519574 0.29289 -0.70711C2.98043 0.605374 3.23478 0.500017 3.5 0.500017h13.29c0.1316 -0.000761 0.2621 0.024464 0.3839 0.074228 0.1218 0.049765 0.2327 0.12309 0.3261 0.215772l3.71 3.710003Z"
          strokeWidth="1"
        ></path>
        <path
          stroke={sx?.color || '#3d517b8f'}
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M11 4.11c0.0254 0.20782 0.0065 0.41867 -0.0555 0.61863 -0.0621 0.19996 -0.1659 0.38448 -0.3045 0.54137 -0.1426 0.15844 -0.3168 0.28513 -0.5115 0.37185 -0.19467 0.08672 -0.40541 0.13154 -0.61852 0.13154 -0.21312 0 -0.42386 -0.04482 -0.61853 -0.13154 -0.19468 -0.08672 -0.36894 -0.21341 -0.51147 -0.37185 -0.14219 -0.15521 -0.24964 -0.33897 -0.31517 -0.539 -0.06552 -0.20003 -0.08763 -0.41174 -0.06483 -0.621L8.36997 0.5H10.5l0.5 3.61Z"
          strokeWidth="1"
        ></path>
        <path
          stroke={sx?.color || '#3d517b8f'}
          d="M9.5011 8.25c-0.13807 0 -0.25 -0.11193 -0.25 -0.25s0.11193 -0.25 0.25 -0.25"
          strokeWidth="1"
        ></path>
        <path
          stroke={sx?.color || '#3d517b8f'}
          d="M9.5011 8.25c0.13807 0 0.25 -0.11193 0.25 -0.25s-0.11193 -0.25 -0.25 -0.25"
          strokeWidth="1"
        ></path>
        <path
          stroke={sx?.color || '#3d517b8f'}
          d="M9.5011 10.75c-0.13807 0 -0.25 -0.1119 -0.25 -0.25s0.11193 -0.25 0.25 -0.25"
          strokeWidth="1"
        ></path>
        <path
          stroke={sx?.color || '#3d517b8f'}
          d="M9.5011 10.75c0.13807 0 0.25 -0.1119 0.25 -0.25s-0.11193 -0.25 -0.25 -0.25"
          strokeWidth="1"
        ></path>
        <path
          stroke={sx?.color || '#3d517b8f'}
          d="M9.5011 13.25c-0.13807 0 -0.25 -0.1119 -0.25 -0.25s0.11193 -0.25 0.25 -0.25"
          strokeWidth="1"
        ></path>
        <path
          stroke={sx?.color || '#3d517b8f'}
          d="M9.5011 13.25c0.13807 0 0.25 -0.1119 0.25 -0.25s-0.11193 -0.25 -0.25 -0.25"
          strokeWidth="1"
        ></path>
        <g>
          <path
            stroke={sx?.color || '#3d517b8f'}
            d="M9.5011 15.75c-0.13807 0 -0.25 -0.1119 -0.25 -0.25s0.11193 -0.25 0.25 -0.25"
            strokeWidth="1"
          ></path>
          <path
            stroke={sx?.color || '#3d517b8f'}
            d="M9.5011 15.75c0.13807 0 0.25 -0.1119 0.25 -0.25s-0.11193 -0.25 -0.25 -0.25"
            strokeWidth="1"
          ></path>
        </g>
        <g>
          <path
            stroke={sx?.color || '#3d517b8f'}
            d="M9.5011 18.25c-0.13807 0 -0.25 -0.1119 -0.25 -0.25s0.11193 -0.25 0.25 -0.25"
            strokeWidth="1"
          ></path>
          <path
            stroke={sx?.color || '#3d517b8f'}
            d="M9.5011 18.25c0.13807 0 0.25 -0.1119 0.25 -0.25s-0.11193 -0.25 -0.25 -0.25"
            strokeWidth="1"
          ></path>
        </g>
        <g>
          <path
            stroke={sx?.color || '#3d517b8f'}
            d="M9.5011 20.75c-0.13807 0 -0.25 -0.1119 -0.25 -0.25s0.11193 -0.25 0.25 -0.25"
            strokeWidth="1"
          ></path>
          <path
            stroke={sx?.color || '#3d517b8f'}
            d="M9.5011 20.75c0.13807 0 0.25 -0.1119 0.25 -0.25s-0.11193 -0.25 -0.25 -0.25"
            strokeWidth="1"
          ></path>
        </g>
      </svg>
    </SvgIcon>
  )
}

ZIPIcon.propTypes = {
  sx: PropTypes.object
}
